import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  outbOrd02ProcessFetchProcess: null,
  outbOrd02ProcessFetchProcessLoading: ['boolean'],
  outbOrd02ProcessFetchProcessSuccess: ['process']
});

export const OutbOrd02ProcessTypes = Types;
export default Creators;
